/**
 * FeedCategoryTabs.js — EcoScienceInnova
 * Horizontal scrollable tabs for filtering feed by category.
 *
 * Props:
 *  - categories: [{ key, label, icon }]
 *  - activeKey:  string
 *  - onChange:   (key) => void
 */
import React from 'react';
import './feed.shared.css';

const FeedCategoryTabs = ({ categories = [], activeKey, onChange }) => {
    return (
        <div className="feed-category-tabs" role="tablist">
            {categories.map(cat => (
                <button
                    key={cat.key}
                    role="tab"
                    aria-selected={activeKey === cat.key}
                    className={`feed-tab ${activeKey === cat.key ? 'active' : ''}`}
                    onClick={() => onChange?.(cat.key)}
                >
                    {cat.icon && <span>{cat.icon}</span>}
                    {cat.label}
                </button>
            ))}
        </div>
    );
};

export default FeedCategoryTabs;
